var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeddingSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7896 2.03803C20.4701 1.75913 22 3.04961 22 4.74614V17.0798H21.9983C21.9994 17.1149 22 17.1503 22 17.1862C22 18.4359 20.6248 19.7576 19.6181 20.5578C19.1624 20.92 18.9345 21.1011 18.5786 21.1011C18.2227 21.1011 17.9948 20.92 17.5391 20.5577C16.5324 19.7576 15.1572 18.4359 15.1572 17.1862C15.1572 15.0985 17.0391 14.319 18.5786 15.9318C19.2114 15.2689 19.9021 15.0101 20.4961 15.0803V9.26309L9.84276 11.0102V18.0851C9.84276 19.3348 8.46756 20.6566 7.46089 21.4567C7.00517 21.8189 6.7773 22 6.42138 22C6.06546 22 5.8376 21.8189 5.38187 21.4567C4.3752 20.6565 3 19.3348 3 18.0851C3 15.9974 4.88181 15.2179 6.42138 16.8307C7.09949 16.1203 7.84401 15.8741 8.46487 15.9993V6.07727C8.46487 4.73518 9.43928 3.5898 10.7687 3.36917L18.7896 2.03803Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeddingSong);
export default __webpack_public_path__ + "static/media/wedding-song.0a8934adb1745cd8f062258f12f6e2b4.svg";
export { ForwardRef as ReactComponent };